const BusinessDepartments = [
  { text: 'Customer Service', value: 'CUSTOMER_SERVICE' },
  { text: 'Finance', value: 'FINANCE' },
  { text: 'Operations', value: 'OPERATIONS' },
  { text: 'Sales', value: 'SALES' },
  { text: 'Other', value: 'OTHER' }
]

export default BusinessDepartments
